<template>
  <div class="ctrl-login">

    <div class="wrap">
    <CtrlLogin />
    </div>



  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CtrlLogin from "@/components/Ctrl/Login.vue";
export default {
  name: 'ctrl-login',
  components: {
    CtrlLogin,
  },
data() {
    return {};
  },
  computed: {
  ...mapGetters(["rootUrl"]),
  },
};
</script>

<style lang="scss" scoped>

</style>
